(()=>{
 const fine=matchMedia('(hover:hover) and (pointer:fine)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
 class ZenfeliDropdowns{
  constructor(nav){
   const signal=(this.abort=new AbortController()).signal;
   const dropdowns=[...nav.querySelectorAll('.nav-left [data-zf-dropdown]')];
   const animations=new Map(),categoryTimers=new Set();
   const desktopHover=()=>fine.matches&&matchMedia('(min-width:981px)').matches;
   const animateCategory=(category,open)=>{
    const previous=animations.get(category),from=category.getBoundingClientRect().height;
    if(previous){previous.cancel();animations.delete(category)}
    category.style.height='';category.style.overflow='';
    if(reduced.matches){category.open=open;category.querySelector('summary').setAttribute('aria-expanded',String(open));return}
    category.open=true;
    const summary=category.querySelector(':scope>summary');summary.setAttribute('aria-expanded',String(open));
    const to=open?category.scrollHeight:summary.getBoundingClientRect().height;
    category.style.overflow='hidden';
    const animation=category.animate([{height:from+'px'},{height:to+'px'}],{duration:420,easing:'cubic-bezier(.22,.61,.36,1)'});
    animations.set(category,animation);
    animation.onfinish=()=>{category.open=open;category.style.height='';category.style.overflow='';animations.delete(category)};
   };
   nav.querySelectorAll('.zf-category').forEach(category=>{
    category.removeAttribute('name');
    const summary=category.querySelector(':scope>summary');summary.setAttribute('aria-expanded',String(category.open));
    let leaveTimer;
    category.addEventListener('pointerenter',()=>{if(!desktopHover())return;clearTimeout(leaveTimer);if(summary.getAttribute('aria-expanded')==='true')return;category.parentElement.querySelectorAll(':scope>.zf-category').forEach(other=>{if(other!==category&&other.open)animateCategory(other,false)});animateCategory(category,true)},{signal});
    category.addEventListener('pointerleave',()=>{if(!desktopHover())return;clearTimeout(leaveTimer);leaveTimer=setTimeout(()=>{categoryTimers.delete(leaveTimer);if(!category.contains(document.activeElement)||!document.activeElement.matches(':focus-visible'))animateCategory(category,false)},140);categoryTimers.add(leaveTimer)},{signal});
    summary.addEventListener('click',event=>{
     if(event.target.closest('.zf-category-link'))return;
     event.preventDefault();
     if(desktopHover()&&event.detail>0){animateCategory(category,summary.getAttribute('aria-expanded')!=='true');return}
     const open=summary.getAttribute('aria-expanded')!=='true';
     if(open)category.parentElement.querySelectorAll(':scope>.zf-category').forEach(other=>{if(other!==category&&other.open)animateCategory(other,false)});
     animateCategory(category,open);
    },{signal});
   });
   const align=dropdown=>{
    const panel=dropdown.querySelector(':scope>.zf-dropdown-panel');if(!panel)return;
    dropdown.style.setProperty('--zf-panel-offset','0px');
    const header=dropdown.closest('.site-header');if(header)dropdown.style.setProperty('--zf-panel-top',(header.getBoundingClientRect().bottom+12-dropdown.getBoundingClientRect().top)+'px');
    const rect=panel.getBoundingClientRect(),width=document.documentElement.clientWidth;
    const offset=rect.left<20?20-rect.left:rect.right>width-20?width-20-rect.right:0;
    dropdown.style.setProperty('--zf-panel-offset',offset+'px');
   };
   // Category hover swaps the right-side desktop image pairs; pointer across to images keeps current pair.
   for(const shopMenu of nav.querySelectorAll('.nav-left .zf-shop-dropdown')){
    const promos=shopMenu.querySelector('.zf-shop-promos');
    if(!promos)continue;
    // Preload only after the user engages with the Shop menu (no eager load on page load).
    let warmed=false;
    const warmImages=()=>{if(warmed)return;warmed=true;promos.querySelectorAll('img[loading="lazy"]').forEach(img=>img.loading='eager');};
    shopMenu.addEventListener('pointerenter',warmImages,{signal});
    shopMenu.addEventListener('focusin',warmImages,{signal});
    const sets=[...promos.querySelectorAll('[data-zf-promo-category]')];
    const activate=key=>{
     if(!desktopHover()||promos.dataset.zfActiveCategory===key)return;
     promos.dataset.zfActiveCategory=key;
     sets.forEach(set=>{
      const selected=set.dataset.zfPromoCategory===key;
      set.dataset.active=String(selected);
      set.setAttribute('aria-hidden',String(!selected));
      set.querySelectorAll('a').forEach(link=>link.tabIndex=selected?0:-1);
     });
    };
    shopMenu.querySelectorAll('.zf-category[data-zf-shop-category]').forEach(category=>{
      category.addEventListener('pointermove',()=>activate(category.dataset.zfShopCategory),{signal});
      category.addEventListener('focusin',()=>activate(category.dataset.zfShopCategory),{signal});
      // Category label is a real collection link; clicking its arrow still toggles the accordion.
      category.querySelector(':scope>summary .zf-category-link')?.addEventListener('click',event=>event.stopPropagation(),{signal});
    });
    shopMenu.addEventListener('toggle',()=>{if(shopMenu.open)activate('home')},{signal});
   }
   for(const dropdown of dropdowns){
    let timer;
    dropdown.querySelector(':scope>summary').addEventListener('click',event=>{if(fine.matches&&event.detail>0){event.preventDefault();dropdown.open=true;align(dropdown)}},{signal});
    dropdown.addEventListener('pointerenter',()=>{if(!fine.matches)return;clearTimeout(timer);dropdowns.forEach(other=>{if(other!==dropdown)other.open=false});dropdown.open=true;align(dropdown)},{signal});
    dropdown.addEventListener('pointerleave',()=>{if(!fine.matches)return;clearTimeout(timer);timer=setTimeout(()=>{if(!dropdown.contains(document.activeElement))dropdown.open=false},220)},{signal});
    dropdown.addEventListener('focusout',event=>{if(!dropdown.contains(event.relatedTarget))dropdown.open=false},{signal});
    dropdown.addEventListener('toggle',()=>{if(dropdown.open)align(dropdown);else dropdown.querySelectorAll('details[open]').forEach(item=>{animations.get(item)?.cancel();animations.delete(item);item.open=false;item.style.height='';item.style.overflow='';item.querySelector('summary').setAttribute('aria-expanded','false')})},{signal});
   }
   document.addEventListener('click',event=>{dropdowns.forEach(dropdown=>{if(!dropdown.contains(event.target))dropdown.open=false})},{signal});
   window.addEventListener('resize',()=>dropdowns.filter(item=>item.open).forEach(align),{signal,passive:true});
   nav.addEventListener('keydown',event=>{if(event.key!=='Escape')return;const dropdown=event.target.closest('[data-zf-dropdown]');if(dropdown?.open){event.preventDefault();dropdown.open=false;dropdown.querySelector('summary').focus()}},{signal});
   this.timers=()=>{categoryTimers.forEach(clearTimeout);animations.forEach(animation=>animation.cancel());dropdowns.forEach(dropdown=>{if(!dropdown.isConnected)dropdown.open=false})};
  }
  destroy(){this.abort.abort();this.timers()}
 }
 class ZenfeliHeader{
  constructor(nav){
   this.nav=nav;this.host=nav.parentElement;this.previousHeight=this.host.style.minHeight;
   if(nav.dataset.experienceHeader==='false'||window.Shopify?.designMode)return;
   const signal=(this.abort=new AbortController()).signal;
   let frame=0,naturalHeight=nav.getBoundingClientRect().height;
   const wrapper=document.querySelector('.page-wrapper');
   const scrollPosition=()=>wrapper&&getComputedStyle(wrapper).overflowY==='auto'?wrapper.scrollTop:window.scrollY;
   const update=()=>{
    frame=0;
    if(!nav.classList.contains('zf-header-docked'))naturalHeight=nav.getBoundingClientRect().height;
    const docked=scrollPosition()>Math.max(140,naturalHeight-20);
    this.host.style.minHeight=docked?naturalHeight+'px':this.previousHeight;
    nav.classList.toggle('zf-header-docked',docked);
   };
   const schedule=()=>{if(!frame)frame=requestAnimationFrame(update)};
   window.addEventListener('scroll',schedule,{signal,passive:true});
   wrapper?.addEventListener('scroll',schedule,{signal,passive:true});
   window.addEventListener('resize',schedule,{signal,passive:true});
   this.resize=new ResizeObserver(schedule);this.resize.observe(nav);
   this.cancel=()=>cancelAnimationFrame(frame);update();
  }
  destroy(){this.abort?.abort();this.resize?.disconnect();this.cancel?.();this.nav.classList.remove('zf-header-docked');this.host.style.minHeight=this.previousHeight}
 }
 const headers=new Map(),mounted=new Map();let observer;
 const init=()=>{
  for(const [nav,controller] of mounted)if(!nav.isConnected){controller.destroy();mounted.delete(nav)}
  for(const [nav,controller] of headers)if(!nav.isConnected){controller.destroy();headers.delete(nav)}
  document.querySelectorAll('zf-navigation').forEach(nav=>{if(!mounted.has(nav))mounted.set(nav,new ZenfeliDropdowns(nav));if(nav.dataset.zfHeaderLayout==='stacked'&&!headers.has(nav))headers.set(nav,new ZenfeliHeader(nav))});
  observer?.disconnect();
  if(reduced.matches||window.Shopify?.designMode)return;
  observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)return;observer.unobserve(entry.target);entry.target.animate([{opacity:0,transform:'translateY(22px)'},{opacity:1,transform:'translateY(0)'}],{duration:1000,easing:'cubic-bezier(.16,1,.3,1)',fill:'backwards'})}),{threshold:.08});
  document.querySelectorAll('[data-zf-reveal]').forEach(el=>observer.observe(el));
 };
 document.addEventListener('shopify:section:load',init);document.addEventListener('shopify:section:unload',init);reduced.addEventListener('change',init);init();
})();
